import React from "react";
import { Checkbox, Tooltip } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import Button from "../../DesignSystem/button";
import Input from "../../DesignSystem/input";
import Textarea from "../../DesignSystem/textarea";
import FormFieldBox from "../../DesignSystem/formFieldBox";
import { YearDaysForCalculation, getPortChargePerMonth } from "../../../utils/appConstants";
import GreenCheckMark from "../../../assets/images/right-green-check-mark.svg";
import InfoIcon from "../../../assets/images/info-icon.svg";
import DollarIcon from "../../../assets/images/dollar.svg";
import CentIcon from "../../../assets/images/cent.svg";
import SwipeIcon from "../../../assets/images/swipe-icon.svg";
import BlueCheckMark from "../../../assets/images/ic-agreement.svg";
import { currencyFormatter } from "../../../utils/methods";
import CheckboxIcon from "../../../assets/images/checkbox-unchecked.svg";
import CheckboxCheckedIcon from "../../../assets/images/checkbox-checked.svg";

export interface PurchaseBandwidthFormProps {
  selectedRowForPurchase: any;
  values: any;
  onContractSelected: boolean;
  agreementSelected: {
    on_contract: boolean;
    on_demand: boolean;
  };
  onDemandSelected: boolean;
  onContractPrice: string;
  onDemandPrice: string;
  disabled: boolean;
  loading: boolean;
  selectedPrice: string;
  mapView?: boolean;
  onBackToListClick?: () => void;
  handlePurchaseClick: () => void;
  handleInputChange: (e: any) => void;
  onAcceptTermsBypass: (_: boolean, s: string) => void;
  onClose: () => void;
  onAggredTermsClick: (_: string) => void;
  onSelectedPriceChange: (_: string) => void;
}

const PurchaseBandwidthForm: React.FC<PurchaseBandwidthFormProps> = ({
  onClose,
  onAggredTermsClick,
  onAcceptTermsBypass,
  onSelectedPriceChange,
  selectedPrice,
  mapView,
  onBackToListClick,
  selectedRowForPurchase,
  values,
  agreementSelected,
  onContractSelected,
  onDemandSelected,
  onContractPrice,
  onDemandPrice,
  disabled,
  loading,
  handlePurchaseClick,
  handleInputChange,
}) => {
  const onContractPerMinute = onContractPrice ? ((parseFloat(onContractPrice) * 100 * 12) / (YearDaysForCalculation * 24 * 60)).toFixed(2) : 0;
  const onDemandPerMonth = onDemandPrice
    ? ((parseFloat(onDemandPrice) / 100) * ((60 * 24 * YearDaysForCalculation) / 12) + getPortChargePerMonth(selectedRowForPurchase) * 2).toFixed(2)
    : 0;
  const onDemandPerMinute = onDemandPerMonth ? ((parseFloat(onDemandPerMonth) * 100 * 12) / (YearDaysForCalculation * 24 * 60)).toFixed(2) : 0;

  let title;

  if (mapView) {
    title = (
      <div className="title-with-back-icon">
        <div>
          <ArrowBackIcon onClick={onBackToListClick} />
          <label>Purchase Link</label>
        </div>
        <div>
          <span>{values.organization}</span>
        </div>
      </div>
    );
  } else {
    title = (
      <div className="title">
        <label>Purchase Link</label>
      </div>
    );
  }

  return (
    <div className="purchase-bandwidth-form">
      <div className="add-group-root">
        {title}
        <div className="form">
          <div className="port-name">
            <div className="nearend-port">
              <label>{selectedRowForPurchase?.near_network_element}</label>
            </div>
            <span className="swipe-icon">
              <img src={SwipeIcon} alt="Swipe" data-testid="swipe-icon" />
            </span>
            <div className="farend-port">
              <label>{selectedRowForPurchase?.far_network_element}</label>
            </div>
            <hr style={{ marginTop: "25px", border: "1px solid #4D4D4D" }} />
            <div>
              <div className="bandwidth-desc">
                <FormFieldBox excludeMarginTop excludeMarginBottom>
                  <label>Link Description</label>
                  <Input
                    variant="input"
                    type="text"
                    min={1}
                    icon={DollarIcon}
                    name="port-description"
                    placeholder={`${selectedRowForPurchase?.organization_name} ${selectedRowForPurchase?.service_description}`}
                    onChange={() => {}}
                    className="port-description"
                    disabled
                  />
                </FormFieldBox>
              </div>
              <div className="bandwidth-port-detail-form">
                <FormFieldBox>
                  <label>Link Name</label>
                  <Input
                    variant="input"
                    placeholder="Use default naming convention (Link 1, Link 2, ext...)"
                    value={values.nePortName}
                    onChange={() => {}}
                    className="port-name-input"
                    name="nePortName"
                    disabled
                  />
                </FormFieldBox>
                <div className="inside">
                  <div style={{ width: "45%" }}>
                    <FormFieldBox>
                      <label>
                        Nearend Group
                      </label>
                      <Input
                        variant="input"
                        type="text"
                        min={1}
                        icon={DollarIcon}
                        name="port-description"
                        placeholder={`${selectedRowForPurchase?.organization_name} ${values.neServiceDescription}`}
                        onChange={() => {}}
                        className="port-description"
                        disabled
                      />
                    </FormFieldBox>
                  </div>
                  <div style={{ width: "45%" }}>
                    <FormFieldBox>
                      <label>
                        Farend Port Description
                      </label>
                      <Input
                        variant="input"
                        type="text"
                        min={1}
                        icon={DollarIcon}
                        name="port-description"
                        placeholder={`${selectedRowForPurchase?.organization_name} ${values.feServiceDescription}`}
                        onChange={() => {}}
                        className="port-description"
                        disabled
                      />
                    </FormFieldBox>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {selectedRowForPurchase?.on_demand_price ? (
            <div className="price">
              <div className="price-box-main">
                <div className="left">
                  <Checkbox
                    classes={{
                      root: "radio",
                    }}
                    color="default"
                    checked={selectedPrice === "on_demand"}
                    onChange={() => onSelectedPriceChange("on_demand")}
                    icon={<RadioButtonUncheckedIcon />}
                    checkedIcon={<img className="checked-icon" src={GreenCheckMark} alt="radio" />}
                  />
                </div>
                <div className="right">
                  <label>On Demand</label>
                  <div>
                    <FormFieldBox className="form-box-price">
                      <label>
                        Price
                        <Tooltip
                          classes={{
                            tooltip: "tooltip",
                          }}
                          arrow
                          placement="right"
                          title="On Demand Services are priced Per Month"
                        >
                          <img className="info-icon" src={InfoIcon} alt="radio" />
                        </Tooltip>
                      </label>
                      <div className="input-main">
                        <div className="price-info">
                          <label>{parseFloat(onDemandPerMinute.toString()).toFixed(2)}</label>
                          <img src={CentIcon} alt="Cent" />
                        </div>
                        <div className="info-text">
                          <span>Per Minute</span>
                        </div>
                      </div>
                      <label className="per-month-price">
                        <Tooltip
                          classes={{
                            tooltip: "tooltip",
                          }}
                          arrow
                          placement="left"
                          title="Price Per Month will vary depending on length of the calendar month"
                        >
                          <span>&cong;&nbsp;$</span>
                        </Tooltip>
                        {currencyFormatter(parseFloat(onDemandPerMonth.toString()))} Per Month
                      </label>
                    </FormFieldBox>
                  </div>
                </div>
              </div>

              <div className="agreement-info">
                <div className="left">
                  <Checkbox
                    classes={{
                      root: "radio",
                    }}
                    color="default"
                    checked={agreementSelected.on_demand && selectedPrice === "on_demand"}
                    onChange={() => onAcceptTermsBypass(!(agreementSelected.on_demand && selectedPrice === "on_demand"), "on_demand")}
                    icon={<img className="checked-icon" src={CheckboxIcon} alt="radio" />}
                    checkedIcon={<img className="checked-icon" src={CheckboxCheckedIcon} alt="radio" />}
                  />
                </div>
                <div className="right">
                  <label>Agreement</label>
                  <p>
                    I have read and accept the <span onClick={() => onAggredTermsClick("on_demand")}>terms and conditions.</span>
                  </p>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          {selectedRowForPurchase?.on_contract_price ? (
            <div className="price">
              <div className="price-box-main">
                <div className="left">
                  <Checkbox
                    classes={{
                      root: "radio",
                    }}
                    color="default"
                    checked={selectedPrice === "on_contract"}
                    onChange={() => onSelectedPriceChange("on_contract")}
                    icon={<RadioButtonUncheckedIcon />}
                    checkedIcon={<img className="checked-icon" src={GreenCheckMark} alt="radio" />}
                  />
                </div>
                <div className="right">
                  <label>Contract</label>
                  <div>
                    <FormFieldBox className="form-box-price">
                      <label>
                        Price
                        <Tooltip
                          classes={{
                            tooltip: "tooltip",
                          }}
                          arrow
                          placement="right"
                          title="Contract Services are priced Per Month"
                        >
                          <img className="info-icon" src={InfoIcon} alt="radio" />
                        </Tooltip>
                      </label>
                      <div className="input-main">
                        <div className="price-info">
                          <img src={DollarIcon} alt="Dollar" />
                          <label>{currencyFormatter(parseFloat(onContractPrice.toString()))}</label>
                        </div>
                        <div className="info-text">
                          <span>Per Month</span>
                          <span>(Calender)</span>
                        </div>
                      </div>
                      <span style={{ paddingTop: "5px" }}>24 Month Contract</span>
                      <label className="per-month-price">
                        <Tooltip
                          classes={{
                            tooltip: "tooltip",
                          }}
                          arrow
                          placement="left"
                          title="Price Per Minute will vary depending on length of the calendar month"
                        >
                          <span>&cong;&nbsp;</span>
                        </Tooltip>
                        {currencyFormatter(parseFloat(onContractPerMinute.toString()))}
                        <span className="cent">
                          <img src={CentIcon} alt="Cent" />
                        </span>{" "}
                        Per Minute
                      </label>
                    </FormFieldBox>
                  </div>
                </div>
              </div>
              <div className="agreement-info">
                <div className="left">
                  <Checkbox
                    classes={{
                      root: "radio",
                    }}
                    color="default"
                    checked={agreementSelected.on_contract && selectedPrice === "on_contract"}
                    onChange={() => onAcceptTermsBypass(!(agreementSelected.on_contract && selectedPrice === "on_contract"), "on_contract")}
                    icon={<img className="checked-icon" src={CheckboxIcon} alt="radio" />}
                    checkedIcon={<img className="checked-icon" src={CheckboxCheckedIcon} alt="radio" />}
                  />
                </div>
                <div className="right">
                  <label>Agreement</label>
                  <p>
                    I have read and accept the <span onClick={() => onAggredTermsClick("on_contract")}>terms and conditions.</span>
                  </p>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="buttons">
          <Button variant="greyed" className="btn cancel-btn" node="Cancel" onClick={onClose} />
          <Button
            variant="primary"
            className="btn"
            node={selectedPrice === "on_demand" || !selectedRowForPurchase?.on_contract_price ? "Reserve Link" : "Purchase Link"}
            disabled={disabled}
            onClick={handlePurchaseClick}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
};

export default PurchaseBandwidthForm;
